module.exports = __webpack_public_path__ + "img/Mode_Selector_RestRoyal.c22b767f.png";